/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IDescriptorBody } from '../../../descriptor';
import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface INumberStringPacketDataMessage extends IPackageDataMessage {
	data: number;
	data1: string;
}

export default class NumberStringPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.NUMBER, MessageDataTypes.STRING ) )();

	public static readonly DESCRIPTOR_NAME: string = 'NumberStringPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'uint32',
				id: 1
			},
			data1: {
				type: 'string',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: number, public readonly data1: string ) {
		super();
	}

	public toJSON(): INumberStringPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1
		};
	}

	public static fromJSON( data: INumberStringPacketDataMessage ): NumberStringPacketDataMessage {
		return new NumberStringPacketDataMessage( data.data, data.data1 );
	}

	public static create( data: number, data1: string ): NumberStringPacketDataMessage {
		return new NumberStringPacketDataMessage( data, data1 );
	}
}
